interface StreetViewMapProps {
  coordinates: [number, number]
  googleMapsKey: string
}

export const StreetViewMap = ({ coordinates, googleMapsKey }: StreetViewMapProps) => (
  <iframe
    width="100%"
    height="100%"
    sandbox="allow-forms allow-scripts allow-same-origin"
    src={`https://www.google.com/maps/embed/v1/streetview?key=${googleMapsKey}&location=${coordinates[1]},${coordinates[0]}`}
    allowFullScreen
  />
)
